<template>
  <section class="has-background-info px-5">
    <div class="container is-max-desktop">
      <div class="columns is-multiline mt-0">
        <div class="column is-8 is-full-mobile my-3">
          <p><strong>Busca tu sucursal con Módulo Express</strong></p>

          <div class="field">
            <label for="seleccionar_region" class="label">Selecciona región*</label>
            <div class="control">
              <span class="select is-fullwidth is-empty">
                <select v-model="selectedRegion" id="seleccionar_region" required>
                  <option disabled value="">Región</option>
                  <option v-for="region in regions" :key="region.value" :value="region.value">
                    {{ region.name }}
                  </option>
                </select>
              </span>
            </div>
          </div>

          <div class="cont-btn">
            <button type="button" class="button is-primary buscarSucursal is-pulled-right mb-3" :disabled="isDisabled"
              @click="emitUpdates()">Buscar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'MexBuscarSucursal',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedRegion: "",
      regions: []
    }
  },
  computed: {
    isDisabled() {
      return this.selectedRegion === "";
    },
    filteredOfficesRegion() {
      if (this.selectedRegion === "") return [];

      const officesInRegion = this.data.offices.filter(office => {
        return office.location_id.startsWith(this.selectedRegion);
      });

      return officesInRegion;
    }
  },
  mounted() {
    this.initializeRegions();
  },
  methods: {
    initializeRegions() {
      this.regions = _.chain(this.data.location)
        .filter(item => item.type === 'region')
        .map(region => ({
          value: region.id,
          name: region.name
        }))
        .value();
    },
    emitUpdates() {
      this.$emit('update:filteredOfficesRegion', this.filteredOfficesRegion);
    }
  }
}
</script>
